<template>
    <div>
      <title-component></title-component>
      <request-tabs></request-tabs>
      <div class="page-containers page-containers-cp">
        <requests></requests>
      </div>
      <session-expired-modal v-if="showSessionExpired"></session-expired-modal>
      <interpreter-secured-modal v-if="showInterpreterSecured"></interpreter-secured-modal>
      <cancel-request-confirm-modal v-if="showCancelRequestConfirm"></cancel-request-confirm-modal>
      <cancel-request-not-saved-modal v-if="showCancelRequestNotSaved"></cancel-request-not-saved-modal>
      <cancel-request-success-modal v-if="showCancelRequestSuccess"></cancel-request-success-modal>
      <request-not-saved-modal v-if="showRequestNotSaved"></request-not-saved-modal>
      <time-conflict-modal v-if="showTimeConflict"></time-conflict-modal>
      <request-max-modal v-if="showRequestMax"></request-max-modal>
      <request-received-modal v-if="showRequestReceived"></request-received-modal>
      <request-cancelled-modal v-if="showRequestCancelled"></request-cancelled-modal>
      <interpreter-not-available-modal v-if="showInterpreterNotAvailable"></interpreter-not-available-modal>
      <interpreter-replaced-modal v-if="showInterpreterReplaced"></interpreter-replaced-modal>
      <last-minute-cancel-modal v-if="showLastMinuteCancel"></last-minute-cancel-modal>
      <location-existed-modal v-if="showLocationExisted"></location-existed-modal>
      <required-field-modal v-if="showRequiredFieldMessage"></required-field-modal>
      <delete-completed-vos-confirm-modal v-if="showDeleteFileConfirm"></delete-completed-vos-confirm-modal>
      <delete-completed-vos-success-modal v-if="showDeleteFileSuccess"></delete-completed-vos-success-modal>
      <upload-completed-vos-success-modal v-if="showUploadFileSuccess"></upload-completed-vos-success-modal>

      <delete-uploaded-vos-confirm-modal v-if="showDeleteVosConfirm"></delete-uploaded-vos-confirm-modal>
      <delete-uploaded-vos-success-modal v-if="showDeleteVosSuccess"></delete-uploaded-vos-success-modal>
      <vos-uploaded-modal v-if="viewUploadedVosModal"></vos-uploaded-modal>
      <vos-digital-modal v-if="viewDigitalVosModal"></vos-digital-modal>
      <view-uploaded-files-modal v-if="viewUploadedFiles"></view-uploaded-files-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data () {
        return {
        }
    },

    computed: {

        ...mapState('notify', {
            showSessionExpired: state => state.showSessionExpired,
            showInterpreterSecured: state => state.showInterpreterSecured,
            showCancelRequestConfirm: state => state.showCancelRequestConfirm,
            showCancelRequestNotSaved: state => state.showCancelRequestNotSaved,
            showCancelRequestSuccess: state => state.showCancelRequestSuccess,
            showRequestReceived: state => state.showRequestReceived,
            showRequestNotSaved: state => state.showRequestNotSaved,
            showTimeConflict: state => state.showTimeConflict,
            showRequestMax: state => state.showRequestMax,
            showRequestCancelled: state => state.showRequestCancelled,
            showInterpreterNotAvailable: state => state.showInterpreterNotAvailable,
            showInterpreterReplaced: state => state.showInterpreterReplaced,
            showLastMinuteCancel: state => state.showLastMinuteCancel,
            showLocationExisted: state => state.showLocationExisted,
            showRequiredFieldMessage: state => state.showRequiredFieldMessage,
            showDeleteFileConfirm: state => state.showDeleteFileConfirm,
            showDeleteFileSuccess: state => state.showDeleteFileSuccess,
            showUploadFileSuccess: state => state.showUploadFileSuccess,
            showDeleteVosConfirm: state => state.showDeleteVosConfirm,
            showDeleteVosSuccess: state => state.showDeleteVosSuccess,
            viewUploadedVosModal: state => state.viewUploadedVosModal,
            viewDigitalVosModal: state => state.viewDigitalVosModal,
            viewUploadedFiles: state => state.viewUploadedFiles,
        }),

        ...mapState('nav', [
            'activeHeaderTab',
            'activeHeaderDisplayName',
        ]),

    },

    methods: {
        // display content based on active tab
        displayMainContent(activeHeaderTab, name){
            return activeHeaderTab === name;
        },

        checkIfStillLoggedIn(){
            var vThis = this;

            VueStore.dispatch('global/getBillingStatus');

            //Run this same function periodically
            var loggedInTimeOut = setTimeout(function(){ vThis.checkIfStillLoggedIn(); }, 30000);
            VueStore.dispatch('auth/setTimeOutVar', loggedInTimeOut);
        },

        initializePage(pageId){
            //console.log(pageId);
            var req_curPos; //Current Position of the slider
            var req_newPos; //New Position of the slider
            var req_totDrag; //Total displacement of the slider when dragged
            var req_curWidthLeft; //Left div, the Form
            var req_curWidthRight; //Right div, the Table
            var req_origResizerPos = 0 //Default slider position
            var resizerOffset = 0; //Default slider offset; the div margin-left
            var pageId;
            var reqResizerOffset = Number($('.requests-resizer').width());
            var paddingAdjustment = 4; //Added to counter the effects of padding added inside the containers

            $(document).ready(function(){
                //Prevent non-numeric characters
                $(".numeric-input").on("keypress blur",function (event) {
                    var charCode = (event.which != 0) ? event.which : (event.keyCode != 0) ? event.keyCode : event.charCode;

                    $(this).val($(this).val().replace(/[^0-9\.]/g,''));
                    if ((charCode != 46 || $(this).val().indexOf('.') != -1) && (charCode < 48 || charCode > 57) && (charCode != 8 && charCode != 37 && charCode != 39 && charCode != 46 && charCode != 9)) {
                        event.preventDefault();
                    }
                });

                setPreviousValues();
                checkSubNavWidth();

                //Fix for the resizer -- prevents it moving when resizing the window
                pageId = getCurrentPage();
                adjustOnResize(pageId);
                
            });

            $(window).resize(function(){
                pageId = getCurrentPage();
                setResizerPosition(pageId);
                adjustOnResize(pageId);
            });

            // on after reload
            window.onload = function(event)
            {
                pageId = getCurrentPage();
                setResizerPosition(pageId);
                setSubNav(pageId);
            };


            $('.requests-resizer-toggle').on('click', function(){
                getContainersCurrentWidth('requests');
                if(req_curWidthLeft > 0){
                    $('.requests-resizer').css({left: '0px'});
                    $('#requests_left').css('width', '0px');
                    $('#requests_left').css('min-width', '');
                    req_curWidthRight = req_curWidthRight + req_curWidthLeft;
                    $('#requests_right').css('width', Number(req_curWidthRight + req_curWidthLeft) + 'px');
                    $('#requests_right').css('min-width', '');
                    $('.requests-sub-nav').css('width', '0px');
                    $('.requests-sub-nav').css('min-width', '');

                    updateLocalStorage('requests', 0, req_curWidthRight);
                }else{
                    if(req_origResizerPos <= 40){
                        req_origResizerPos = 470;
                    }

                    $('.requests-resizer').css({left: Number(req_origResizerPos + resizerOffset) + 'px'});
                    $('#requests_left').css('width', req_origResizerPos + 'px');
                    $('#requests_left').css('min-width', '');
                    $('#requests_right').css('width', Number(req_curWidthRight - req_origResizerPos + reqResizerOffset) + 'px');
                    $('#requests_right').css('min-width', '');
                    $('.requests-sub-nav').css('width', req_origResizerPos + 'px');
                    $('.requests-sub-nav').css('min-width', '');

                    updateLocalStorage('requests', req_origResizerPos,Number(req_curWidthRight - req_origResizerPos));
                }

                checkSubNavWidth();

            });

            $('.requests-resizer').draggable({
                containment: '.requests-container',
                start: function(){
                    $('.requests-resize-overlay').fadeIn('fast');
                    req_curPos = $(this).offset().left;
                },
                stop: function(){
                    $('.requests-resize-overlay').fadeOut('fast');
                    req_newPos = $(this).offset().left;

                    getContainersCurrentWidth('requests');

                    req_totDrag = Math.abs(req_curPos - req_newPos);

                    if(req_curPos > req_newPos){
                        //Direction is Right-to-Left
                        req_totDrag = req_totDrag + paddingAdjustment;

                        $('#requests_left').css('width', Number(req_curWidthLeft - req_totDrag + (reqResizerOffset / 2)) + 'px');
                        $('#requests_left').css('min-width', Number(req_curWidthLeft - req_totDrag + (reqResizerOffset / 2)) + 'px');
                        $('#requests_right').css('width', Number(req_curWidthRight + req_totDrag + (reqResizerOffset / 2)) + 'px');
                        //$('#requests_right').css('min-width', Number(req_curWidthRight + req_totDrag + (reqResizerOffset / 2)) + 'px');
                        $('.requests-sub-nav').css('width', Number(req_curWidthLeft - req_totDrag + (reqResizerOffset / 2)) + 'px');
                        $('.requests-sub-nav').css('min-width', Number(req_curWidthLeft - req_totDrag + (reqResizerOffset / 2)) + 'px');
                        req_origResizerPos = Number(req_curWidthLeft - req_totDrag);

                        updateLocalStorage('requests', Number(req_curWidthLeft - req_totDrag), Number(req_curWidthRight + req_totDrag));

                    }else{
                        //Direction is Left-to-Right
                        req_totDrag = req_totDrag - paddingAdjustment;

                        $('#requests_left').css('width', Number(req_curWidthLeft + req_totDrag + (reqResizerOffset / 2)) + 'px');
                        $('#requests_left').css('min-width', Number(req_curWidthLeft + req_totDrag + (reqResizerOffset / 2)) + 'px');
                        $('#requests_right').css('width', Number(req_curWidthRight - req_totDrag + (reqResizerOffset / 2)) + 'px');
                        //$('#requests_right').css('min-width', Number(req_curWidthRight - req_totDrag + (reqResizerOffset / 2)) + 'px');
                        $('.requests-sub-nav').css('width', Number(req_curWidthLeft + req_totDrag + (reqResizerOffset / 2)) + 'px');
                        $('.requests-sub-nav').css('min-width', Number(req_curWidthLeft + req_totDrag + (reqResizerOffset / 2)) + 'px');
                        req_origResizerPos = Number(req_curWidthLeft + req_totDrag);

                        updateLocalStorage('requests', Number(req_curWidthLeft + req_totDrag), Number(req_curWidthRight - req_totDrag));
                    }
                },

                cancel: '.resizer-toggle'
            });

            function checkSubNavWidth(){
                // Hide the sub nav as it bleeds outside of the div
                var subNavWidth = $('.requests-sub-nav').width();

                if(subNavWidth == 0){
                    //hide info
                    $('.requests-sub-nav').hide();
                } else {
                    //hide info
                    $('.requests-sub-nav').show();
                    pageId = getCurrentPage();
                    setResizerPosition(pageId);
                    setSubNav(pageId);
                }
            }

            function getContainersCurrentWidth(pageId){
                var pageIdAbbr = pageId.substring(0, 3);
                eval(pageIdAbbr + "_curWidthLeft = $('#" + pageId + "_left').width();");
                eval(pageIdAbbr + "_curWidthRight = $('#" + pageId + "_right').width();");

            }

            function adjustOnResize(pageId){
                var pageIdAbbr = pageId.substring(0, 3);
                var resizerOffset = 0;
                var left_width = sessionStorage.getItem(pageIdAbbr + "-curWidthLeft");
                
                $('#' + pageId + '_left').css('min-width', left_width+'px');

                //var left_width =  $('#' + pageId + '_left').css('width').replace('px','');

                var right_width = 0;
                var widthNow = jQuery(window).width();

                right_width = (widthNow - (resizerOffset * 2)) - left_width;

                
                sessionStorage.setItem(pageIdAbbr + "-curWidthRight", right_width);
                
                $('.'+pageId+'-resizer').css('left', (Number(left_width) + Number(resizerOffset)) + 'px');

                $('#' + pageId + '_right').css('width', right_width+'px');
                
            }

            function getCurrentPage(){
                return sessionStorage.getItem("ACTIVE-HEADER-TAB");
            }

            function setInitialLocalSorageValues(pageId){
                var leftDiv, rightDiv;

                leftDiv = (0.4 * Number($('.' + pageId + '-container').width()));
                rightDiv = (0.6 * Number($('.' + pageId + '-container').width()));

                updateLocalStorage(pageId, leftDiv, rightDiv);
                setInitialWidths(pageId, leftDiv, rightDiv);

            }

            function setInitialWidths(pageId, leftDiv, rightDiv){
                $('#' + pageId + '_left').css('width', leftDiv+'px');
                $('#' + pageId + '_right').css('width', rightDiv+'px');
                $('.' + pageId + '-sub-nav').css('width', leftDiv+'px');

                setResizerPosition(pageId);

            }


            function setPreviousValues(){
                var pageId = getCurrentPage();
                var pageIdAbbr = pageId.substring(0, 3);

                //localStorage not yet set up
                if(eval("sessionStorage.getItem('"+pageIdAbbr+"-curWidthLeft') === null || sessionStorage.getItem('"+pageIdAbbr+"-curWidthRight') === null")){
                    setInitialLocalSorageValues(pageId);
                    setResizerPosition(pageId);
                }else{
                    //requests
                    req_curWidthLeft = Number(sessionStorage.getItem("req-curWidthLeft"));
                    req_curWidthRight = Number(sessionStorage.getItem("req-curWidthRight"));
                    $('#requests_left').css('width', req_curWidthLeft + 'px');
                    $('.requests-sub-nav').css('width', req_curWidthLeft + 'px');
                    $('#requests_right').css('width', req_curWidthRight + 'px');
                    $('.requests-resizer').css('left', Number(req_curWidthLeft + resizerOffset) + 'px');

                    eval(pageIdAbbr + "_curWidthLeft = $('#" + pageId + "_left').width();");

                }

            }

            function setResizerPosition(pageId){
                // only applies to requests page
                if(pageId === 'requests'){
                    getContainersCurrentWidth(pageId);
                    var pageIdAbbr = pageId.substring(0, 3);
                    $('.' + pageId + '-resizer').css({left: Number(eval(pageIdAbbr + '_curWidthLeft') + resizerOffset)+'px'});
                }
            }

            function setSubNav(pageId){
                var pageIdAbbr = pageId.substring(0, 3);
                $('.' + pageId + '-sub-nav').css({width: Number(eval(pageIdAbbr + '_curWidthLeft') + resizerOffset)+'px'});
            }


            function updateLocalStorage(pageId, leftDivPos, rightDivPos){
                var pageIdAbbr = pageId.substring(0, 3);

                eval("sessionStorage.setItem('"+pageIdAbbr+"-curWidthLeft', leftDivPos);");
                eval("sessionStorage.setItem('"+pageIdAbbr+"-curWidthRight', rightDivPos);");

            }
        },

    },

    created(){
    },

    mounted(){
        this.initializePage('requests');
    }

};
</script>